module.exports = __webpack_public_path__ + "img/sintesis.ff458f92.svg";